import Reflux from 'reflux';

const actions = Reflux.createActions({
  setStartLoginPage: {},
});

export default actions;
